<template>
  <div class="fanmenu">
    <div class="tl1 flex_start fanCollapse">
      <div class="labe">已选条件：</div>
      <div class="yxtj">
        <el-tag
          v-if="activlist.wt1"
          closable
          :disableTransitions="true"
          @close="handleClose('wt1')"
          type="info"
        >
          {{ activlist.wt1.cat_name }}
        </el-tag>
        <el-tag
          v-if="activlist.wt2"
          closable
          :disableTransitions="true"
          @close="handleClose('wt2')"
          type="info"
        >
          {{ activlist.wt2.cat_name }}
        </el-tag>
      </div>
    </div>
    <fanCollapse
      class="fananxxqy"
      :tagify="menulist"
      ref="wt1"
      @clitag="clitag($event, 'wt1')"
    />
    <fanCollapse
      class="fananxxqy"
      v-if="menulist[menuact] && menulist[menuact].children"
      :tagify="menulist[menuact].children"
      ref="wt2"
      @clitag="clitag($event, 'wt2')"
    />
  </div>
</template>

<script>
import fanCollapse from "../components/fanCollapse";
export default {
  components: {
    fanCollapse,
  },
  data: () => ({
    menulist: [],
    menuact: 0,
    activlist: {
      wt1: null,
      wt2: null,
    },
    soluId: 0,
  }),
  beforeMount() {
    this.getmenu();
  },
  methods: {
    clitag(e, index) {
      if (index == "wt1") {
        if (!e) {
          this.activlist = { wt1: null, wt2: null };
          this.menuact = 0;
        } else {
          this.activlist[index] = e;
          let chindex = this.menulist.findIndex((item) => item.id == e.id);
          this.menuact = chindex;
        }
      } else {
        this.activlist[index] = e;
      }
      if (index == "wt1" && !e) {
        this.soluId = 0;
      } else {
        e ? (this.soluId = e.id) : (this.soluId = this.activlist.wt1.id);
      }
      this.$store.commit('jpcol/upsoluId',this.soluId)
    },
    handleClose(tag) {
      this.$refs[tag].condi("-1");
    },
    getmenu() {
      this.$http.jpcol.getsolutionify().then((res) => {
        this.menulist = res.data;
        console.log(this.menulist);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.fanmenu {
  width: 1200px;
  margin: 0 auto;
  padding: 20px 24px 0;
  border: 1px solid #eeeeee;
  .fananxxqy {
    border-bottom: 1px solid #eee;
    padding: 20px 0;
    &:last-child {
      border-bottom: none;
    }
  }
  .tl1 {
    color: #999999;
    .labe {
      padding: 2px 4px 2px 15px;
      line-height: 30px;
    }
    .yxtj {
      width: 900px;
    }
    .el-tag.el-tag--info {
      color: #333333;
      background-color: #f8f8f8;
    }
    .el-tag {
      margin-right: 10px;
    }
  }
}
</style>



